export default "__VITE_ASSET__e1Zk2NbF__"